'use strict';

/**
 *
 */
angular.
module('moebiusProadapt').
factory('mbsUser', function mbsUserFactory($rootScope)
{
    var userObject = {};

    userObject.init = function (userData, centresData, groupsData, asmData)
    {
        // Vérifie si l'utilisateur a les droits pour AU MOINS UN des droits dans l'array rightsNeeded
         $rootScope.userHasRight =  (rightsNeeded, user = null) =>{
            user = user == null ? this.user : user;
            rightsNeeded = !Array.isArray(rightsNeeded) ? [rightsNeeded] : rightsNeeded;

            for(let i = 0 ; i < rightsNeeded.length; i++){
                if(user.rights.includes(rightsNeeded[i])){
                    return true;
                }
            }
            return false;
        }

        $rootScope.userHasRole =  (roleChecked) =>{
            return $rootScope.constants.user.role == roleChecked;
        };

        $rootScope.rights = {};
        $rootScope.roles = $rootScope.constants.roles.NAMES_TO_VALUES;

        Object.values($rootScope.constants.rights).map((rights) => {
            rights.map((r) => {
                $rootScope.rights[r] = r;
            })
        });

        this.user     = userData;
        this.user.rights = $rootScope.constants.rights[$rootScope.constants.user.role];

        console.log(" $rootScope.constants", $rootScope.constants);

        if (centresData) {
            this.centresById  = centresData;

            if ( ! $rootScope.userHasRight($rootScope.rights.ADMIN) && !this.user.is_arc_user_with_more_right ) {
                delete this.centresById[$rootScope.constants.misc_constants.TEST_CENTER_ID];
            }

        }
    };

    return userObject;

});




// WEBPACK FOOTER //
// ./resources/assets/js/services/mbs-user-service.js